import React from "react";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { PhotoCameraIcon } from "../icons";

type CameraUploadButtonProps = {
  isDisabled?: boolean;
  onCameraClick?: () => void;
};

const CameraUploadButton = ({
  isDisabled = false,
  onCameraClick,
}: CameraUploadButtonProps) => {
  const handleCameraClick = () => {
    onCameraClick?.();
  };

  return (
    <Button
      onClick={handleCameraClick}
      isDisabled={isDisabled}
      bgColor="brand.100"
      color="brand.500"
      borderRadius="100rem"
      py={2.5}
      px={4}
      pl={1}
      width="full"
      _hover={{
        bgColor: "brand.200",
      }}
      _active={{
        bgColor: "brand.200",
      }}
    >
      <Flex align="center" gap={3} justify="center">
        <Box
          width={8}
          height={8}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <PhotoCameraIcon boxSize={8} />
        </Box>
        <Flex direction="column" align="center" justify="center">
          <Text fontSize="sm" fontWeight="bold" textAlign="center">
            カメラを起動して撮影
          </Text>
          <Text
            fontSize="xs"
            fontWeight="normal"
            lineHeight="1.1"
            textAlign="center"
          >
            (スマホ・タブレット向け)
          </Text>
        </Flex>
      </Flex>
    </Button>
  );
};

export default CameraUploadButton;
